
//LOGO IMPORTS
import logoDefault from '../Assets/images/Logo/SIMDEV_Logo_NoBackground.png'
import LogoMinimalist from '../Assets/images/Logo/SIMDEV_Logo-minimalist.jpg'
import LogoCircle from '../Assets/images/Logo/SIMDEV-white-circle.png'

//TEAM PHOTO IMPORTS
import fullTeam from '../Assets/images/Company/Stock Images/team_stock.jpeg'

export const Title = "SIMDEV"

export const Team = {
  ceo: {
    name: "Luc Simard"
  },
  coo: {
    name: "Redouane Fadadi"
  },
  cfo: {

  },
  picture: fullTeam,
  
}

export const Logo_Default = logoDefault
export const Logo_Minimalist = LogoMinimalist
export const Logo_Circle = LogoCircle

export enum View {
  Desktop = "desktop",
  Tablet = "tablet",
  LargeTablet = "largeTablet",
  Mobile = "mobile"
}

// Project 
export enum ProjectType {
  Commercial,
  Residential
}

// Social media links
export const links = {
  facebook: " ",
  linkedin: "https://www.linkedin.com/company/construction-simdev-inc-",
  twitter: " ",
}

export enum ProjectLocation{
  
}

// Colors (mirror the scss) for code
export const colors = {
  main: {
    light: "#FFFFFF",
    dark: "rgb(16, 26, 44)",
  },
  secondary: {
    lightBlue: "#36a9e0",
    grey: "#878786",
    lightGray: "#f3f3f3",
  },
  input: {
    bg: "hsla(60, 0%, 53%, 6.5%)",
    bgHover: "hsla(60, 0%, 53%, 13%)",
  },
  oviv: {
    pms471c: "#B86125",
    pms7510c: "#C7913D",
    pms7590c: "#CFB594",
    pms7527c: "#E5E5D4", // Principal "beige"
    pms5793c: "#B5B28F",
    pms7763c: "#5E664F",
    pms5487c: "#4A696E",
    pmsGreen: "#4E8F6B",
    pmsneutralblackc: "#26241C" // Principal "black"
  },
  levivo:{

  },
  simdev:{
    midnightBlue: "#0f1a2c",
    lightBlue: "#3d9ed8",
    gray: "#b3b2b2",
    light_gray: "#ececec"
  }
};

